import SettingsComponent from "../../../../components/settings/SettingsComponent.vue"

export default [
    {
        path: '/settings',
        name: 'Settings',
        meta: { layout: 'mystagit' },
        component: SettingsComponent,
    },
]